module.exports = {
          srcSet: __webpack_public_path__ + "1338e16421e70561519c4243860b3f31-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "1338e16421e70561519c4243860b3f31-1168.png",width: 1168,height: 210}],
          src: __webpack_public_path__ + "1338e16421e70561519c4243860b3f31-1168.png",
          toString:function(){return __webpack_public_path__ + "1338e16421e70561519c4243860b3f31-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AExZ9v1eavf/UF32/jxK9f8iM/j/QULM/2RXnv92aZf+Y1ip/0JDyvsAN0b19z5M9v8vPvX+KTj1/yg39P8jMvP/PEXY/2hps/40P+L/JTPv9b44MCUkQUMhAAAAAElFTkSuQmCC",
          width: 1168,
          height: 210
        }